import { StyleSheet, View } from 'react-native';
import { tokens } from '../../theme/tokens';
import { AppCard } from '../ui/AppCard';
import { AppText } from '../ui/AppText';

type ProfileHeaderProps = {
  displayName: string;
  gradeName: string;
  avatarLabel: string;
  streakDays: number;
  completedTaskCount: number;
};

export function ProfileHeader({
  displayName,
  gradeName,
  avatarLabel,
  streakDays,
  completedTaskCount,
}: ProfileHeaderProps) {
  return (
    <AppCard style={styles.card}>
      <View style={styles.avatar}>
        <AppText variant="subtitle" weight="bold" tone="primary">
          {avatarLabel}
        </AppText>
      </View>
      <View style={styles.copy}>
        <AppText variant="title" weight="bold">
          {displayName}
        </AppText>
        <AppText variant="body" tone="muted">
          {gradeName} · 连续学习 {streakDays} 天
        </AppText>
        <AppText variant="caption" tone="muted">
          已完成 {completedTaskCount} 个学习任务
        </AppText>
      </View>
    </AppCard>
  );
}

const styles = StyleSheet.create({
  card: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: tokens.spacing.md,
  },
  avatar: {
    width: 58,
    height: 58,
    borderRadius: tokens.radius.full,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: tokens.colors.surfaceMuted,
  },
  copy: {
    flex: 1,
    gap: tokens.spacing.xs,
  },
});
